export default __webpack_public_path__ + "static/media/996.0b2f562f.png";